import {Controller, useFormContext} from "react-hook-form";
import {Checkbox, Space} from "antd";
import {LiveEventSettingsFormFieldsType} from "../types";
import {FormFieldError} from "../../../../../design-system/form-field";

export function LiveEventCloseRegistrationSettingFormField() {
  const {control} = useFormContext<LiveEventSettingsFormFieldsType>();
  return (
    <div>
      <Controller
        control={control}
        name="closeRegistration"
        render={({field: {value, onChange, ref}, fieldState: {error}}) => (
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <Checkbox
              onChange={(e) => onChange(e.target.checked)}
              ref={ref}
              checked={value}
            >
              Close registrations
            </Checkbox>
            <FormFieldError errorMessage={error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
